import React from "react";
import "../../style/Partners.css";
import phdcciLogo from "../../resources/phdcci.png";
import ducatLogo from "../../resources/ducat.png";
import dimensionNextLogo from "../../resources/dimensionnext.png";
import adityaBirlaLogo from "../../resources/adityabirla.png";
import testbookLogo from "../../resources/testbook.png";
import clEducateLogo from "../../resources/cl_educate.png";
import edunetLogo from "../../resources/edunet.png";
import techsharksLogo from "../../resources/techsharks.png";

function Partners() {
  const industrialPartners = [
    { name: "PHDCCI", logo: phdcciLogo },
    { name: "DUCAT", logo: ducatLogo },
    { name: "Dimension Next", logo: dimensionNextLogo },
    { name: "Aditya Birla", logo: adityaBirlaLogo },
  ];

  const technicalPartners = [
    { name: "Testbook", logo: testbookLogo },
    { name: "CL Educate Limited", logo: clEducateLogo },
    { name: "Edunet Foundation", logo: edunetLogo },
    { name: "Tech Sharks", logo: techsharksLogo },
  ];

  return (
    <div className="partners-section">
      <h2>Our Partners</h2>
      <div className="partners-container">
        <div className="technical-partners">
          <h3>Technical Partners</h3>
          <div className="partners-logos">
            {technicalPartners.map((partner, index) => (
              <div key={index} className="partner-card">
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>

        <div className="industrial-partners">
          <h3>Industrial Partners</h3>
          <div className="partners-logos">
            {industrialPartners.map((partner, index) => (
              <div key={index} className="partner-card">
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
